export function ComposerPromptPlaceholder({ text }: { readonly text: string }) {
  return (
    <div
      data-composer-placeholder="true"
      className="pointer-events-none absolute inset-0 text-[length:var(--forge-prompt-font-size,14px)] font-[family-name:var(--font-composer,var(--font-sans))] leading-relaxed text-muted-foreground/70"
    >
      {text}
    </div>
  );
}
